export default "__VITE_ASSET__B_QRv5U9__"